import { ArrowRight, PackageCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { formatDate } from '@/utils/format';

import type { Order } from '@/features/orders/orders.types';

interface OrdersAtPlaceSectionProps {
  orders: Order[];
  total_count: number;
}

const STATUS_LABEL: Record<string, string> = {
  at_dispatch_place: 'En punto',
};

/**
 * Dashboard section listing orders currently sitting at a dispatch place
 * waiting to be picked up. A CTA links to the full orders view.
 */
export function OrdersAtPlaceSection(props: OrdersAtPlaceSectionProps) {
  return (
    <section className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold">Órdenes en punto</h2>
          <span className="badge badge-warning">{props.total_count}</span>
        </div>
        <Link to="/orders" className="btn btn-ghost btn-sm gap-1 text-primary">
          Ver todas
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      {props.orders.length === 0 ? (
        <div className="card border border-base-300 bg-base-100">
          <div className="card-body items-center py-10 text-base-content/40">
            <PackageCheck className="h-10 w-10" />
            <p className="text-sm">Sin órdenes en punto ahora mismo.</p>
          </div>
        </div>
      ) : (
        <div className="card border border-base-300 bg-base-100">
          <div className="overflow-x-auto">
            <table className="table table-sm w-full">
              <thead>
                <tr>
                  <th>Guía</th>
                  <th>Cliente</th>
                  <th>Punto</th>
                  <th>Estado</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                {props.orders.map((order) => (
                  <tr key={order.id}>
                    <td className="font-semibold font-mono text-xs">{order.tracking_number}</td>
                    <td>{order.customer_name}</td>
                    <td>{order.dispatch_place_name}</td>
                    <td>
                      <span className={twMerge('badge badge-sm', 'badge-warning')}>
                        {STATUS_LABEL[order.status] ?? order.status}
                      </span>
                    </td>
                    <td className="text-xs text-base-content/60">{formatDate(order.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  );
}
